import { render, staticRenderFns } from "./130.vue?vue&type=template&id=53ddf996&scoped=true&"
var script = {}
import style0 from "./130.vue?vue&type=style&index=0&id=53ddf996&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53ddf996",
  null
  
)

export default component.exports